import React from "react";
import "../../css/Wireframe.css";
import Banner from "../../components/Banner";
import Select from "react-select";
import axios from "axios";
import OtpInput from "../../components/OtpInput";
import Spinner from "../../components/Spinner";

const API = localStorage.getItem("assethost");
const emailRegex =
  /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)+$/i;
const emailError = "Please enter a valid email address (e.g. name@example.com)";
const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
const passwordError =
  "Password must be at least 8 characters, with uppercase, lowercase, number, and symbol.";
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";
const nationalIdRegex = /^\d{2}-\d{6,7}[A-Z]\d{2}$/;
const ogPlaceholder = "00-000000(0)A00";
const placeholder1 = "00-000000A00";
const placeholder2 = "00-0000000A00";

function dynamicNationalIdError(id) {
  const start = "Accepted format for national ID is ";
  let last = "";
  if (id.length >= 10 && /[A-Z]/.test(id[9])) {
    last = id + placeholder1.substring(id.length);
  } else if (id.length >= 10) {
    last = id + placeholder2.substring(id.length);
  } else {
    last = id + ogPlaceholder.substring(id.length);
  }
  return start + last;
}

function getNestedValue(obj, path) {
  return path.split(".").reduce((acc, key) => acc && acc[key], obj);
}
function setNestedValue(obj, path, value) {
  const keys = path.split(".");
  const lastKey = keys.pop();
  const newObj = { ...obj };
  let curr = newObj;
  for (const k of keys) {
    curr[k] = { ...curr[k] };
    curr = curr[k];
  }
  curr[lastKey] = value;
  return newObj;
}

function formatNationalId(e, currentObject, field, isZimbabwean = true) {
  let currentValue = String(getNestedValue(currentObject, field) || "");
  let newValue = currentValue;
  let newPlaceholder =
    currentValue + ogPlaceholder.substring(currentValue.length);
  let error = "";
  e = e.toUpperCase();
  if (!isZimbabwean) {
    const updatedObject = setNestedValue(currentObject, field, e);
    return { newPlaceholder, error, updatedObject };
  }
  if (e.length > currentValue.length && nationalIdRegex.test(currentValue)) {
    return { newPlaceholder, error, updatedObject: currentObject };
  }
  if (nationalIdRegex.test(e)) {
    newValue = e;
    newPlaceholder = e;
  } else if (
    nationalIdRegex.test(e + placeholder1.substring(e.length)) ||
    nationalIdRegex.test(e + placeholder2.substring(e.length))
  ) {
    if (e.length >= 10) {
      if (/[A-Z]/.test(e[9])) {
        newValue = e;
        newPlaceholder = e + placeholder1.substring(e.length);
      } else {
        newValue = e;
        newPlaceholder = e + placeholder2.substring(e.length);
      }
    } else if (e.length === 2 && currentValue.length < 2) {
      newValue = e + "-";
      newPlaceholder = newValue + ogPlaceholder.substring(newValue.length);
    } else {
      newValue = e;
      newPlaceholder = e + ogPlaceholder.substring(e.length);
    }
  } else {
    error = dynamicNationalIdError(currentValue);
  }
  const updatedObject = setNestedValue(currentObject, field, newValue);
  return { newPlaceholder, error, updatedObject };
}

export default class Individual extends React.Component {
  constructor(props) {
    super(props);
    // All fields from original IndividualReg
    this.state = {
      firstname: "",
      middlename: "",
      surname: "",
      identification: "",
      passportNumber: "",
      nationality: "",
      townCityId: 0,
      email: "",
      cellphone: "",
      address: "",
      suburb: "",
      gender: "",
      username: "",
      password: "",
      passwordConfirm: "",
      serviceType: "",
      mobileMoney: "",
      errors: {},
      idPlaceholder: ogPlaceholder,
      msg: "",
      toastColor: "",
      individualLookupData: {},
      showCellVerifyPopup: false,
      showVerifyPopup: false,
      mobileMoneyVerified: false,
      cellOtp: "",
      cellOtpId: undefined,
      cellVerified: false,
      loading: false,
      valid: true,
    };
    this.handleRegister = this.handleRegister.bind(this);
    this.handleId = this.handleId.bind(this);
    this.getIndividualLookupData = this.getIndividualLookupData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleVerifyMobileMoney = this.handleVerifyMobileMoney.bind(this);
    this.handleAcceptMobileMoney = this.handleAcceptMobileMoney.bind(this);
    this.handleCancelMobileMoney = this.handleCancelMobileMoney.bind(this);
    this.verifyCellphone = this.verifyCellphone.bind(this);
    this.verifyCellphoneOtp = this.verifyCellphoneOtp.bind(this);
  }

  componentDidMount() {
    this.getIndividualLookupData();
  }
  isZimbabwean() {
    return this.state.nationality === "ZW";
  }

  // Field change (input) handlers always call validate
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }
  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handleId(val, field = "identification") {
    const { newPlaceholder, error, updatedObject } = formatNationalId(
      val,
      this.state,
      field,
      this.isZimbabwean()
    );
    this.setState(
      {
        [field]: updatedObject[field],
        ...(field === "identification"
          ? { idPlaceholder: newPlaceholder }
          : {}),
        errors: { ...this.state.errors, [field]: error },
      },
      this.validate
    );
  }

  // Validation: no arrays, strict per-field if/else (patientaction.js style)
  validate() {
    let errors = {};
    let valid = true;
    // Firstname
    if (!this.state.firstname || !this.state.firstname.trim()) {
      errors.firstname = "Firstname is required";
      valid = false;
    }
    // Surname
    if (!this.state.surname || !this.state.surname.trim()) {
      errors.surname = "Surname is required";
      valid = false;
    }
    // Nationality
    if (!this.state.nationality || !this.state.nationality.trim()) {
      errors.nationality = "Nationality is required";
      valid = false;
    }
    // ID/Passport
    if (this.isZimbabwean()) {
      if (!this.state.identification || !this.state.identification.trim()) {
        errors.identification = "National ID is required";
        valid = false;
      } else if (!nationalIdRegex.test(this.state.identification)) {
        errors.identification = dynamicNationalIdError(
          this.state.identification
        );
        valid = false;
      }
    } else {
      if (!this.state.passportNumber || !this.state.passportNumber.trim()) {
        errors.passportNumber = "Passport Number is required";
        valid = false;
      }
    }
    // Address
    if (!this.state.address || !this.state.address.trim()) {
      errors.address = "House No & Street (address) is required";
      valid = false;
    }
    // Suburb
    if (!this.state.suburb || !this.state.suburb.trim()) {
      errors.suburb = "Suburb is required";
      valid = false;
    }
    // Town/City
    if (!this.state.townCityId || this.state.townCityId === 0) {
      errors.townCityId = "Town/City is required";
      valid = false;
    }
    // Gender
    if (!this.state.gender || !this.state.gender.trim()) {
      errors.gender = "Gender is required";
      valid = false;
    }
    // Username
    if (!this.state.username || !this.state.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(this.state.username)) {
      errors.username = usernameError;
      valid = false;
    }
    // Password
    if (!this.state.password || !this.state.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    } else if (!passwordRegex.test(this.state.password)) {
      errors.password = passwordError;
      valid = false;
    }
    // Password Confirm
    if (!this.state.passwordConfirm || !this.state.passwordConfirm.trim()) {
      errors.passwordConfirm = "Password confirm is required";
      valid = false;
    } else if (this.state.password !== this.state.passwordConfirm) {
      errors.passwordConfirm = "Passwords do not match";
      valid = false;
    } else if (!passwordRegex.test(this.state.passwordConfirm)) {
      errors.passwordConfirm = passwordError;
      valid = false;
    }
    // Service Type
    if (!this.state.serviceType || !this.state.serviceType.trim()) {
      errors.serviceType = "Service Type is required";
      valid = false;
    }
    // Cellphone
    if (!this.state.cellphone || !this.state.cellphone.trim()) {
      errors.cellphone = "Cellphone is required";
      valid = false;
    } else if (!phoneRegex.test(this.state.cellphone)) {
      errors.cellphone = phoneError;
      valid = false;
    } else if (!this.state.cellOtpId || this.state.cellOtpId === 0) {
      errors.cellphone = "Cellphone is not verified";
      valid = false;
    }
    // Email (optional, validate format if present)
    if (
      !!this.state.email &&
      this.state.email.trim() &&
      !emailRegex.test(this.state.email)
    ) {
      errors.email = emailError;
      valid = false;
    }
    // Mobile money logic (if serviceType=PAID)
    if (this.state.serviceType === "PAID") {
      if (!this.state.mobileMoney || !this.state.mobileMoney.trim()) {
        errors.mobileMoney = "Mobile Money Number is required";
        valid = false;
      } else if (!this.state.mobileMoneyVerified) {
        errors.mobileMoney = "Mobile Money Number must be verified";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleRegister(e) {
    e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      this.setState({ loading: false });
      return;
    }
    const req = {
      user: {
        username: this.state.username,
        password: this.state.password,
        userType: "INDIVIDUAL",
        fullName: [
          this.state.firstname,
          this.state.middlename,
          this.state.surname,
        ].join(" "),
        mobileVerified: this.state.mobileMoneyVerified ? "YES" : "NO",
        activeStatus: "YES",
        emailVerified: "NO",
        isPaidService: "NO",
      },
      profile: {
        firstName: this.state.firstname,
        middleName: this.state.middlename,
        surname: this.state.surname,
        nationalIdNumber: this.state.identification,
        passportNumber: this.state.passportNumber,
        cellPhone: this.state.cellphone,
        gender: this.state.gender,
        email: this.state.email,
        mobileMoneyNumber: this.state.mobileMoney,
        nationality: this.state.nationality,
        houseNumberStreet: this.state.address,
        suburb: this.state.suburb,
        townCityId: this.state.townCityId,
      },
    };
    var self = this;
    axios
      .post(API + "/register/individualsave", req)
      .then(function (response) {
        if (response.data.success) {
          self.setState({
            msg: "Registration successful! Redirecting to login...",
            toastColor: "success",
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 1600);
        } else {
          self.setState({
            msg: response.data.message || "Registration failed",
            toastColor: "danger",
          });
          if (
            response.data.message &&
            response.data.message.includes("username already exist")
          ) {
            self.setState({
              errors: { ...self.state.errors, username: response.data.message },
            });
          }
        }
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Registration failed. Please try again.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  handleVerifyMobileMoney() {
    // Simulate API call to verify mobile money.
    this.setState({ showVerifyPopup: true });
  }
  handleAcceptMobileMoney() {
    this.setState(
      { mobileMoneyVerified: true, showVerifyPopup: false },
      this.validate
    );
  }
  handleCancelMobileMoney() {
    this.setState(
      { mobileMoneyVerified: false, mobileMoney: "", showVerifyPopup: false },
      this.validate
    );
  }

  getIndividualLookupData() {
    var self = this;
    axios
      .get(API + "/register/getindividualdropdownlists")
      .then(function (response) {
        self.setState(
          { individualLookupData: response.data || {} },
          self.validate
        );
      })
      .catch(function (error) {
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to get lookup data. Refresh page or contact administrator.",
          toastColor: "danger",
        });
      });
  }

  async verifyCellphone(e) {
    if (e) e.preventDefault();
    this.setState({ showCellVerifyPopup: true });

    e.preventDefault();
    this.setState({ loading: true, msg: "", toastColor: "" });

    if (!this.state.cellphone) {
      const errors = this.state.errors;
      errors.cellphone = "Cellphone is required";
      this.setState({ errors, valid: false, loading: false });
      return;
    }
    if (!phoneRegex.test(this.state.cellphone)) {
      const errors = this.state.errors;
      errors.cellphone = phoneError;
      this.setState({ errors, valid: false, loading: false });
      return;
    }

    await axios
      .post(API + "/register/mobile/generateotpcode", null, {
        params: {
          mobile: this.state.cellphone,
        },
      })
      .then((response) => {
        this.setState(
          { cellOtpId: response.data, showCellVerifyPopup: true },
          this.validate
        );
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          msg: error?.response?.data?.message || "Failed to get OTP.",
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }
  verifyCellphoneOtp(otp) {
    // Should handle OTP verification and set cellVerified true if ok (omitted).
    this.setState({
      cellOtp: otp,
      cellVerified: true,
      showCellVerifyPopup: false,
    });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }
    const lookup = s.individualLookupData;
    if (s.loading) {
      return <Spinner className="" />;
    }
    return (
      <div className="d-flex flex-column min-vh-100">
        <Banner title="Register as Individual" align="center" />
        {divMsg}
        <form
          className="d-flex flex-column align-items-center w-100 mt-2 was-validated"
          autoComplete="off"
          onSubmit={this.handleRegister}
        >
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10 card bg-body-tertiary p-3 shadow">
                <h5 className="card-title fw-bold mb-3">Individual Details</h5>
                <div className="row g-4">
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Firstname</span>
                        <input
                          name="firstname"
                          className={`form-control ${s.errors.firstname ? "z-0" : "z-0"
                            }`}
                          value={s.firstname}
                          onChange={this.handleChange}
                          required
                          autoFocus
                        />
                      </div>
                      {s.errors.firstname && (
                        <div className="text-danger small">{s.errors.firstname}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Middle Name</span>
                        <input
                          name="middlename"
                          className={`form-control ${s.errors.middlename ? "z-0" : "z-0"
                            }`}
                          value={s.middlename}
                          onChange={this.handleChange}
                        />
                      </div>
                      {s.errors.middlename && (
                        <div className="text-danger small">{s.errors.middlename}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Surname</span>
                        <input
                          name="surname"
                          className={`form-control ${s.errors.surname ? "z-0" : "z-0"
                            }`}
                          value={s.surname}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      {s.errors.surname && (
                        <div className="text-danger small">{s.errors.surname}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Nationality</span>
                        <Select
                          value={(lookup.countrys || []).filter(
                            ({ value }) => value === s.nationality
                          )}
                          onChange={(e) => {
                            this.handleId("", "identification");
                            this.handleId("", "passportNumber");
                            this.setState({ idPlaceholder: ogPlaceholder });
                            this.handleSelect("nationality", e ? e.value : "");
                          }}
                          className={`form-select ${s.errors.nationality ? "" : ""}`}
                          required
                          options={lookup.countrys || []}
                          
                        />
                      </div>
                      {s.errors.nationality && (
                        <div className="text-danger small">{s.errors.nationality}</div>
                      )}
                    </div>
                  </div>
                  {!!s.nationality && this.isZimbabwean() ? (
                    <div className="col-12 col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">National ID</span>
                          <input
                            name="identification"
                            className={`form-control ${s.errors.identification ? "z-0" : "z-0"
                              }`}
                            value={s.identification}
                            placeholder={s.idPlaceholder}
                            onChange={(e) =>
                              this.handleId(e.target.value, "identification")
                            }
                            required
                          />
                        </div>
                        {s.errors.identification && (
                          <div className="text-danger small">{s.errors.identification}</div>
                        )}
                      </div>
                    </div>
                  ) : !!s.nationality ? (
                    <div className="col-12 col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">Passport Number</span>
                          <input
                            name="passportNumber"
                            className={`form-control ${s.errors.passportNumber ? "z-0" : "z-0"
                              }`}
                            value={s.passportNumber}
                            onChange={(e) =>
                              this.handleId(e.target.value, "passportNumber")
                            }
                            required
                          />
                        </div>
                        {s.errors.passportNumber && (
                          <div className="text-danger small">{s.errors.passportNumber}</div>
                        )}
                      </div>
                    </div>
                  ) : null}
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Gender</span>
                        <select
                          name="gender"
                          className={`form-control ${s.errors.gender ? "z-0" : "z-0"}`}
                          value={s.gender}
                          onChange={this.handleChange}
                          required
                        >
                          <option value="">Select</option>
                          {(lookup.genders || []).map((gender) => (
                            <option key={gender} value={gender}>
                              {gender}
                            </option>
                          ))}
                        </select>
                      </div>
                      {s.errors.gender && (
                        <div className="text-danger small">{s.errors.gender}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Cellphone</span>
                        <input
                          name="cellphone"
                          className={`form-control ${s.errors.cellphone ? "z-0" : "z-0"
                            }`}
                          value={s.cellphone}
                          onChange={this.handleChange}
                          required={true}
                        />
                        {!s.cellVerified &&
                          s?.errors?.cellphone?.includes("verified") && (
                            <button
                              type="button"
                              className="btn btn-outline-primary"
                              onClick={this.verifyCellphone}
                            >
                              Verify
                            </button>
                          )}
                      </div>
                      {s.errors.cellphone && (
                        <div className="text-danger small">{s.errors.cellphone}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Email</span>
                        <input
                          name="email"
                          type="email"
                          className={`form-control ${s.errors.email ? "z-0" : "z-0"
                            }`}
                          value={s.email}
                          onChange={this.handleChange}
                        />
                      </div>
                      {s.errors.email && (
                        <div className="text-danger small">{s.errors.email}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">House No & Street</span>
                        <input
                          name="address"
                          className={`form-control ${s.errors.address ? "z-0" : "z-0"
                            }`}
                          value={s.address}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      {s.errors.address && (
                        <div className="text-danger small">{s.errors.address}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Suburb</span>
                        <input
                          name="suburb"
                          className={`form-control ${s.errors.suburb ? "z-0" : "z-0"
                            }`}
                          value={s.suburb}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      {s.errors.suburb && (
                        <div className="text-danger small">{s.errors.suburb}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Town/City</span>
                        <Select
                          value={(lookup.townCitys || []).filter(
                            ({ value }) => value === s.townCityId
                          )}
                          onChange={(e) =>
                            this.handleSelect("townCityId", e ? e.value : 0)
                          }
                          className={`form-control ${s.errors.townCityId ? "" : ""}`}
                          required
                          options={lookup.townCitys || []}
                        />
                      </div>
                      {s.errors.townCityId && (
                        <div className="text-danger small">{s.errors.townCityId}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="input-group  has-validation">
                      <span className="input-group-text">Username</span>
                      <input
                        name="username"
                        className={`form-control ${s.errors.username ? "z-0" : "z-0"
                          }`}
                        value={s.username}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    {s.errors.username && (
                      <div className="invalid-feedback">{s.errors.username}</div>
                    )}
                  </div>
                  <div className="col-12 col-md-6"></div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Password</span>
                        <input
                          name="password"
                          type="password"
                          className={`form-control ${s.errors.password ? "z-0" : "z-0"
                            }`}
                          value={s.password}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      {s.errors.password && (
                        <div className="text-danger small">{s.errors.password}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Password Confirm</span>
                        <input
                          name="passwordConfirm"
                          type="password"
                          className={`form-control ${s.errors.passwordConfirm ? "z-0" : "z-0"
                            }`}
                          value={s.passwordConfirm}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                      {s.errors.passwordConfirm && (
                        <div className="text-danger small">{s.errors.passwordConfirm}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text">Service Type</span>
                        <select
                          name="serviceType"
                          className={`form-control ${s.errors.serviceType ? "z-0" : "z-0"
                            }`}
                          value={s.serviceType}
                          onChange={this.handleChange}
                          required
                        >
                          <option value="">Select</option>
                          {(lookup.serviceTypes || []).map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                      {s.errors.serviceType && (
                        <div className="text-danger small">{s.errors.serviceType}</div>
                      )}
                    </div>
                  </div>
                  {s.serviceType === "PAID" && (
                    <div className="col-12 col-md-6">
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text">Mobile Money Number</span>
                          <input
                            name="mobileMoney"
                            className={`form-control ${s.errors.mobileMoney ? "z-0" : "z-0"
                              }`}
                            value={s.mobileMoney}
                            onChange={this.handleChange}
                            required={s.serviceType === "PAID"}
                          />
                          {!s?.errors?.mobileMoney && (
                            <button
                              className="btn btn-outline-primary"
                              type="button"
                              onClick={this.handleVerifyMobileMoney}
                            >
                              Verify Now
                            </button>
                          )}
                        </div>
                        {s.errors.mobileMoney && (
                          <div className="text-danger small">{s.errors.mobileMoney}</div>
                        )}
                        {s.showVerifyPopup && (
                          <div className="mt-2 p-3 border rounded bg-light">
                            <button
                              type="button"
                              className="btn btn-primary me-2"
                              onClick={this.handleAcceptMobileMoney}
                            >
                              Accept
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={this.handleCancelMobileMoney}
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-center gap-4 mt-4 mb-4">
                {s.valid && (
                  <button type="submit" className="btn btn-primary">
                    <i className="bi bi-check-circle me-2"></i>Register
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => window.history.back()}
                >
                  <i className="bi bi-x-circle me-2"></i>Cancel
                </button>
              </div>
            </div>
          </div>
        </form>
        {s.showCellVerifyPopup && (
          <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-start justify-content-center z-50" style={{ paddingTop: '80px' }}>
            <div className="bg-white rounded-bottom w-100" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
              <Banner
                key={`poll-message-banner`}
                title="Verify cellphone number"
              />
              <div className="d-flex flex-column align-items-center justify-content-center p-4">
                <p className="mb-3">
                  Please check and enter the code received via your cellphone
                  number.
                </p>
                <div className="p-4 border border-primary rounded">
                  <OtpInput
                    length={5}
                    key={`mobile-money-otp`}
                    onComplete={(code) => {
                      this.setState({ cellOtp: code }, () =>
                        this.verifyCellphoneOtp(code)
                      );
                    }}
                    onReset={(code) => this.setState({ cellOtp: code })}
                  />
                </div>
                <button
                  className="btn btn-primary mt-4"
                  onClick={() => {
                    this.setState({
                      cellOtp: "",
                      cellOtpId: undefined,
                      showCellVerifyPopup: false,
                    });
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    );
  }
}
